<script>
import { mapGetters } from 'vuex';
import PixiHeat from '@/components/pixi/PixiHeat';
import config from '@/config';
import TipsMsg from '@/components/ui/TipsMessage';
import TweenMax, {Power3, Linear} from "gsap/TweenMax";

export default {
  name: 'Heat',
  components: {
    PixiHeat,
    TipsMsg
  },
  data() {
    return {
      trackName: 'heat-trame',
      leaving: false,
    }
  },
  computed: {
    ...mapGetters({
      viewport: 'App/viewport',
      locale: 'I18n/locale',
    }),
  },
  watch: {
    viewport() {
      this.resize(this.viewport.width, this.viewport.height);
    },
  },
  mounted() {
    config.ga('canicule', this.locale);

    //preload future stuff
     if(!this.$store.getters['Preload/hasPreload']('Heat')) {
      this.$store.dispatch('Preload/START', "Heat");
    }
    
    this.$store.dispatch('Sound/FADE', {
      fromSound: this.trackName,
      volumeFrom: 0,
      volumeTo: config.SOUNDS[this.trackName].volume,
      duration: 2
    });

    // display bubble
    this.$store.dispatch('Interface/SHOW_BUBBLES');

    // show bg
    TweenMax.from(this.$el, 1, {alpha:0, ease:Linear.easeNone, delay:.5});
    TweenMax.to(this.$el.querySelector('.gradient-bg-after'), 2.5, {alpha:1, ease:Linear.easeNone, delay:4});
  },
  methods: {
    resize(w, h) {
      this.$refs.pixi.resize(w, h);
    },

    onLeaving() {
      this.leaving = true;

      setTimeout( () => {
        this.$store.dispatch('Interface/HIDE_BUBBLES');
      }, 500);

      this.$store.dispatch('Sound/FADE', {
        fromSound: this.trackName,
        volumeTo: 0,
        duration: 1
      });

      TweenMax.from(this.$refs.Leaving, 1.5, {alpha:0, ease:Power3.easeInOut, onComplete: () => {
        
        TweenMax.delayedCall(.25, () => {
          this.$router.push({name:"Prelude", params: { id:"death" } });
        })
      }});
    }
  }
}
</script>

<template>
  <div class="Heat">
      <div ref="GradientBefore" class="gradient-bg"></div>
      <div ref="GradientAfter" class="gradient-bg-after"></div>
      <pixi-heat @leave="onLeaving" ref="pixi" />
      <tips-msg label-id="heat" />
      <div ref="Leaving" :class="['leaving-bg', {'-leaving': leaving}]"></div>
  </div>
</template>


<style scoped lang="scss">
.Heat {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }
}

.leaving-bg, .gradient-bg, .gradient-bg-after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $c-white;
  opacity: 1;
  display: none;

  &.-leaving {
    display: block;
    z-index: 1
  }
}

.gradient-bg {
  background: linear-gradient(to bottom, #ffffff 0%, #ffffff 50%, #5f635a 50%, #5f635a 100%);
  display: block;
  opacity: 1;
}

.gradient-bg-after {
  display: block;
  opacity: 0;
  background: linear-gradient(to bottom, #ffffff 0%, #ffffff 50%, #61362f 50%, #61362f 100%);
}
</style>
